import * as React from 'react';
import { useRouter } from 'next/router';

import type { PostType } from '@blockworks/platform/api/strapi';
import { Spinner } from '@blockworks/ui';

import { withExceptionCatcher } from '@/components/hoc/with-exception-catcher';
import AboutPageLayout from '@/components/pages/static/layouts/about/about-page-layout';
import AdvertisePageLayout from '@/components/pages/static/layouts/advertise/advertise-page-layout';
import ContactUsPageLayout from '@/components/pages/static/layouts/contact-us/contact-us-page-layout';
import DefaultStaticLayout from '@/components/pages/static/layouts/default-static-layout';
import WordpressPageLayout from '@/components/pages/static/layouts/wordpress-page-layout';
import type { WebinarStripped } from '@/types/article-type';
import type { WordpressPage } from '@/utils/functions/wordpress/fetch-pages';

export interface StaticPageControllerProps {
    layout: string;
    page?: WordpressPage;
    featuredResearchPost?: PostType | null;
    featuredWebinar?: WebinarStripped | null;
}

export const StaticPageController = (props: StaticPageControllerProps) => {
    const router = useRouter();

    switch (props.layout) {
        case 'about':
            return <AboutPageLayout {...(props as React.ComponentProps<typeof AboutPageLayout>)} />;
        /*
        case 'clients':
            return (
                <ClientsPageLayout
                    header={{
                        title: "You're in good company",
                        subTitle: 'Clients',
                        description: 'Some of our trusted advertising clients below.',
                    }}
                />
            ); */
        case 'advertise':
            return <AdvertisePageLayout />;
        case 'contact-us':
            return <ContactUsPageLayout />;
        default:
            if (props.page) {
                if (router.isFallback) {
                    return (
                        <div className="flex align-center justify-center p-12">
                            <Spinner />
                        </div>
                    );
                }
                return (
                    <WordpressPageLayout
                        featuredResearchPost={props.featuredResearchPost}
                        featuredWebinar={props.featuredWebinar}
                        page={props.page}
                    />
                );
            }

            return <DefaultStaticLayout {...props} />;
    }
};

export default withExceptionCatcher(StaticPageController);
